import { type FeatureFlagStatus } from '@gonfalon/openapi/types';
import { z } from 'zod';

const flagStatusNameSchema = z.enum(['new', 'inactive', 'active', 'launched']);

export function assertFlagStatusName(name: unknown): asserts name is FeatureFlagStatus['name'] {
  flagStatusNameSchema.parse(name);
}
